import React from 'react';

const Backend = () => {
    return (
        <div className='skills_content'>
            <h3 className='skills_title'>Backend Developer</h3>

            <div className='skills_box'>
                <div className="skills_group">
                    <div className='skills_data'>
                        <i className="uil uil-shield-check"></i>

                        <div>
                            <h3 className='skills_name'>PHP</h3>
                        </div>
                    </div>

                    <div className='skills_data'>
                        <i className="uil uil-shield-check"></i>

                        <div>
                            <h3 className='skills_name'>MYSQL</h3>
                        </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className='skills_data'>
                        <i className="uil uil-shield-check"></i>

                        <div>
                            <h3 className='skills_name'>Laravel</h3>
                        </div>
                    </div>

                    <div className='skills_data'>
                        <i className="uil uil-shield-check"></i>

                        <div>
                            <h3 className='skills_name'>Firebase</h3>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Backend;
